module.exports = __webpack_public_path__ + "static/media/icon_time_filter.12bfa44a.svg";